import {HttpClient} from "@angular/common/http";
import {Component, OnInit} from "@angular/core";
import {ToastrService} from "ngx-toastr";
import {Language} from "../../../models/language";
import {LanguageControllerService} from "../../../services/language-controller/language-controller.service";
import {TranslatedBaseError} from "../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: "language",
  templateUrl: "./language.component.html",
  styleUrls: ["./language.component.css"],
})
export class LanguageComponent extends TranslatedBaseError implements OnInit {

  public languages: Language[] = [];
  public selectedLanguages: Language[] = [];
  public selectedLanguage: Language = undefined;

  constructor(private languageService: LanguageControllerService,
              private http: HttpClient, toastr: ToastrService,
              public translateService: TranslateService) {
    super(toastr, translateService);
    this.http.get("./assets/language-codes/language-codes.json")
      .subscribe((res: Language[]) => this.languages = res);
  }

  public ngOnInit() {
    this.loadLanguages();
  }

  public loadLanguages() {
    this.languageService.getAllLanguages().subscribe(
      (data) => this.selectedLanguages = data,
      (error) => this.showErrorMessage(error),
    );
  }

  public addLanguage() {
    if (this.selectedLanguage) {
      this.languageService.addLanguage(this.selectedLanguage.id).subscribe(
        (data) => {
          this.responseSuccessful("New language added!");
          this.updateData();
        },
        (error) => this.showErrorMessage(error),
      );
    }
  }

  public updateData() {
    this.loadLanguages();
    this.selectedLanguage = undefined;
  }

  public selected(lan: Language): void {
    this.selectedLanguage = lan;
  }

  public removeLanguage(isConfirmed, code) {
    if (isConfirmed) {
      this.languageService.removeLanguage(code).subscribe(
        (data) => {
          this.responseSuccessful("Language removed!");
          this.loadLanguages();
        },
        (error) => this.showErrorMessage(error),
      );
    }
  }

  public onChange(code: string, active: boolean) {
    this.languageService.activateLanguage(code, active).subscribe(
      (data) => {
        this.responseSuccessful(active ? "Language activated!" : "Language deactivated!");
        if (active) {
          this.translateService.addLangs([code]);
        } else {
          const index = this.translateService.langs.indexOf(code);
          if (index !== -1) {
            this.translateService.langs.splice(index, 1);
          }
        }
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public activateLanguageRTL(code: string, active: boolean) {
    this.languageService.activateRTL(code, active).subscribe(
        (data) => this.responseSuccessful(active ? "RTL activated!" : "RTL deactivated!"),
        (error) => this.showErrorMessage(error),
    );
  }

}
